import PeopleIcon from '@mui/icons-material/People';
import { ProfilesList } from './ProfilesList';
import { ProfilesEdit } from './ProfilesEdit';

const profiles = {
  list: ProfilesList,
  edit: ProfilesEdit,
  icon: PeopleIcon,
};

export default profiles;
